import {
  IFormDocument,
  IInput,
  ISelect,
} from 'app/services/api5-service/api.interface';

import { DocHelper } from 'utils/dochelper';

import {
  InputControlWithValue,
  SelectControlWithValue,
  TypedControl,
  TypedControlBase,
} from '../../controls';

export interface PhoneControlWithValue extends TypedControlBase {
  readonly type: 'phone';
  readonly control: IInput;
  readonly select: ISelect;
  value: string;
  selectValue: string;
}

/**
 * Merge input and select controls for phone group
 *
 * @param controls
 * @param doc
 */
export function getPhoneControls(
  controls: TypedControl[],
  doc: IFormDocument,
): TypedControl[] {
  if (controls.length < 2) {
    return controls;
  }

  const copy = [...controls];

  const inputIndex = copy.findIndex(
    control => control.type === 'input' && control.control.$prefixselect,
  );

  if (inputIndex === -1) {
    return controls;
  }

  const input = copy.splice(inputIndex, 1)[0] as InputControlWithValue;

  const selectIndex = copy.findIndex(
    control =>
      control.type === 'select' &&
      control.control.$name === input.control.$prefixselect,
  );

  if (selectIndex === -1) {
    return controls;
  }

  const select = copy.splice(selectIndex, 1)[0] as SelectControlWithValue;

  const phone: PhoneControlWithValue = {
    type: 'phone',
    control: input.control,
    select: select.control,
    value: input.value,
    // take value for select from doc, not from typed form. Mixed phone case
    selectValue: DocHelper.getSelectValue(select.control.$name, doc),
  } as PhoneControlWithValue;

  return [phone, ...copy];
}
